import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux'
import InputField from '../../../helpers/Fields/InputField';
import { required, email } from 'redux-form-validators'
import PropTypes from 'prop-types'
import { createStudent } from '../../actions';
import Spiner from '../../../helpers/Spiner/Spiner';


class FormContent extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  constructor(props) {
    super(props)
    this.state = {
      spiner: false,
    }
  }
  

  submit = async (values)=> {
    const {formatMessage} = this.context;
    try {
      const {handleClose} = this.props;
      this.setState({spiner: true});
      await this.props.createStudent(values);
      this.setState({spiner: false});
      handleClose();
    } catch (error) {
      this.setState({spiner: false});
    }
    
  }

  render() {
    const {formatMessage} = this.context;
    const { spiner } = this.state;
    const { handleSubmit, handleClose, initialValues } = this.props;
    return (
      <form className="create-dialog-form" style={{position: 'relative'}} onSubmit={handleSubmit(this.submit)}>
        {spiner && <div style={{position: 'absolute', display: 'flex', background: 'rgba(255, 255, 255, 0.4)', alignItems: 'center', width: '100%', height: '100%'}}>
          <Spiner />
        </div>}
        <Field 
          name='firstname'
          label={formatMessage('txtCaptionStudentFirstName')}
          component={InputField}
          validate={[required()]}
        />

        <Field 
          name='lastname'
          label={formatMessage('txtCaptionStudentLastName')}
          component={InputField}
          validate={[required()]}
        />

        <Field 
          name='email'
          label={formatMessage('txtCaptionStudentEmail')}
          component={InputField}
          validate={[required(), email()]}
        />
       
        
        <div className="create-dialog-form__group flex" style={{justifyContent: 'space-between',
            flexDirection: 'row'}}>
          <button className="btn btn-warning" type="button" onClick={() => {
            handleClose();
          }}>{formatMessage('btnModalCancel')}</button>
           <button className="btn btn-primary" type="submit">{formatMessage(!initialValues.id ? 'btnModalCreate': 'btnModalUpdate')}</button>
        </div>
         
      </form>
    );
  }
}

FormContent = reduxForm({
  form: 'form_student',
  enableReinitialize: true,
})(FormContent);



const mapStateToProps = (state, ownProps) => ({
  
})

const mapDispatchToProps = {
  createStudent,
}

export default connect(mapStateToProps, mapDispatchToProps)(FormContent);



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Students/components/FormModal/FormContent.jsx